import React, { useLayoutEffect, useRef } from "react";

const AnimatedContainer: React.FC<{
  children: React.ReactNode;
  questionId: string;
  disableAnimation?: boolean;
}> = ({ children, questionId, disableAnimation = false }) => {
  const containerRef = useRef<HTMLDivElement | null>(null);

  const showedAnimations = JSON.parse(
    sessionStorage.getItem("hasSeenAnimation") || "{}"
  );

  const isSeenAnimation = !!showedAnimations[questionId];

  useLayoutEffect(() => {
    if (!disableAnimation && !isSeenAnimation && containerRef.current) {
      sessionStorage.setItem(
        "hasSeenAnimation",
        JSON.stringify({
          ...showedAnimations,
          [questionId]: "Seen",
        })
      );

      const childrenElements =
        containerRef.current.querySelectorAll(":scope > *");
      containerRef.current.style.opacity = "1";

      childrenElements.forEach((element, index) => {
        const htmlElement = element as HTMLElement;
        htmlElement.style.opacity = "0";
        htmlElement.classList.add("animate-fade-in");
        htmlElement.style.animationDelay = `${index * 0.6}s`;
      });
    }
  }, [questionId, disableAnimation, isSeenAnimation]);

  if (disableAnimation || isSeenAnimation) {
    return children;
  }

  return (
    <div ref={containerRef} className="opacity-0">
      {children}
    </div>
  );
};

export { AnimatedContainer };
